<template>
    <img
        v-if="sources == null || sources.length === 0"
        :alt="alt"
        class="view-media"
        :src="value"
        :srcset="srcset"
        :loading="lazy || invisible ? 'lazy' : undefined"
        :width="size != null ? size.width : undefined"
        :height="size != null ? size.height : undefined"
        :style="{
            'aspect-ratio':
                size != null && enforceAspectRatio
                    ? `${size.width} / ${size.height}`
                    : undefined,
        }"
    />
    <picture v-else>
        <template v-if="sources != null">
            <source
                v-for="source in sources"
                :srcset="source.srcset"
                :type="source.type"
            />
        </template>
        <img
            :alt="alt"
            class="view-media"
            :src="value"
            :srcset="srcset"
            :loading="lazy || invisible ? 'lazy' : undefined"
            :width="size != null ? size.width : undefined"
            :height="size != null ? size.height : undefined"
            :style="{
                'aspect-ratio':
                    size != null && enforceAspectRatio
                        ? `${size.width} / ${size?.height}`
                        : undefined,
            }"
        />
    </picture>
</template>

<style scoped>
:global(.view-media) {
    object-fit: contain;
    object-position: center center;
}
</style>

<script setup lang="ts">
import { type PropType, getCurrentInstance, onMounted, ref } from "vue";
const invisible = ref(true);

defineProps({
    enforceAspectRatio: {
        type: Boolean,
    },
    value: {
        type: String,
        required: true,
    },
    srcset: String,
    alt: String,
    size: {
        type: Object as PropType<{
            width: number;
            height: number;
        }>,
    },
    sources: {
        type: Array as PropType<
            {
                srcset: string;
                type: string;
            }[]
        >,
    },
    lazy: Boolean,
});
const instance = getCurrentInstance();
import { elementVisible } from "../../../frontend-productgallery/element-intersection";
onMounted(() => {
    if (instance == null) throw new Error("missing instance");
    if (instance.proxy == null) throw new Error("instance proxy is null");
    invisible.value = elementVisible(instance.proxy.$el as HTMLElement) === 0;
});
</script>
